import { useQuery } from '@tanstack/react-query';

import config from '@/config';
import { logger } from '@/config/logger';

import { SERVICE_WORKER_NAME } from '../../config';
import { useHandleUpdate } from './hooks/useHandleUpdate';
import { useRegister } from './hooks/useRegister';

export const ServiceWorkerLoader = () => {
    const supported = globalThis.navigator && 'serviceWorker' in globalThis.navigator;
    const enabled = supported && config.serviceWorker;

    const register = useRegister();
    const handleUpdate = useHandleUpdate();

    logger.debug('Service worker enabled:', enabled);

    useQuery({
        queryKey: ['service-worker'],
        queryFn: async () => {
            const { Serwist } = await import('@serwist/window');

            // the path is relative in the `build` output
            const serwist = new Serwist(`../${SERVICE_WORKER_NAME}`, {
                scope: '/',
                type: 'module',
                updateViaCache: 'none',
            });

            handleUpdate(serwist);

            logger.debug('Registering service worker...');

            await register(serwist);

            logger.debug('Service worker registered');

            return null;
        },
        enabled,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    useQuery({
        queryKey: ['unregister-service-worker'],
        queryFn: async () => {
            // eslint-disable-next-line compat/compat
            const registration = await globalThis.navigator.serviceWorker.getRegistration('/');

            if (registration) {
                await registration.unregister();
            }

            return null;
        },
        enabled: supported && !config.serviceWorker,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    return null;
};
